<script setup>
import {ref, toRef} from "vue";
import validator from "../../components/Validator";
import AddressAutoComplete from "./AddressAutoComplete.vue";
import schemaCollection from "../../components/SchemaCollection";

const props = defineProps({
  modelValue: {
    type: Object,
  }
})

const modelValue = toRef(props, 'modelValue');

props.modelValue.isValid = props.modelValue.isValid || false;
props.modelValue.suffix = props.modelValue.suffix || '';
props.modelValue.job = props.modelValue.job || '';
modelValue.value.address = modelValue.value.address || {};

const errors = ref({});
const validate = validator(schemaCollection.invoice, modelValue, errors)
</script>

<template>
  <div class="formfields">
    <div class="entry__divider">
      <div class="entry__field entry__field--md">
        <label for="firstName">Voornaam<span class="required-indicator">*</span></label>
        <input type='text' id="firstName" placeholder="Voornaam" v-model="modelValue.firstName" aria-label='Voornaam' required  @blur="validate('firstName')"/>
        <p class="input-error" v-if="!!errors.firstName">
          {{ errors.firstName }}
        </p>
      </div>

      <div class="entry__field entry__field--sm">
        <label for="initials">Voorletters<span class="required-indicator">*</span></label>
        <input type='text' placeholder="A" v-model="modelValue.initials" id="initials" aria-label='Voorletters' required/>
      </div>
    </div>


    <div class="entry__divider">
      <div class="entry__field entry__field--sm">
        <label for="prefix">Tussenvoegsel</label>
        <input type='text' id="prefix" placeholder="Bijv. de" v-model="modelValue.prefix" aria-label='Tweede naam' />
      </div>

      <div class="entry__field entry__field--md">
        <label id="lastname">Achternaam<span class="required-indicator">*</span></label>
        <input type='text' id="lastname" placeholder="Achternaam" v-model="modelValue.lastName" aria-label='Achternaam' @blur="validate('lastName')" required/>
        <p class="input-error" v-if="!!errors.lastName">
          {{ errors.lastName }}
        </p>
      </div>
    </div>

    <div class="entry__field">
      <label for="organisation">Organisatie<span class="required-indicator">*</span></label>
      <input type="text" v-model="modelValue.organisation" id="organisation" @blur="validate('organisation')" placeholder="Naam organisatie">
      <p class="input-error" v-if="!!errors.organisation">
        {{ errors.organisation }}
      </p>
    </div>

    <div class="entry__field">
      <label for="reference">Referentie <span class="option">Optioneel</span></label>
      <input type="text" v-model="modelValue.reference" id="reference" placeholder="Referentie">
    </div>

    <div class="entry__field">
      <label for="phone">Telefoonnummer<span class="required-indicator">*</span></label>
      <input type="text" v-model="modelValue.phone" id="phone" placeholder="Telefoonnummer">
    </div>

    <div class="entry__field">
      <label for="email">E-mailadres<span class="required-indicator">*</span></label>
      <input id="email" type='email' placeholder="organisatie@provider.nl" v-model="modelValue.email" required @blur="validate('email')" />
      <p class="input-error" v-if="!!errors.email">
        {{ errors.email }}
      </p>
    </div>

    <AddressAutoComplete v-model="modelValue.address" />

  </div>
</template>